var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 175C141.421 175 175 141.421 175 100C175 58.5786 141.421 25 100 25C58.5786 25 25 58.5786 25 100C25 141.421 58.5786 175 100 175Z",
    fill: "url(#paint0_linear_2900_22921)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2900_22921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 68.5H143C145.485 68.5 147.5 70.5147 147.5 73V178C147.5 180.485 145.485 182.5 143 182.5H57C54.5147 182.5 52.5 180.485 52.5 178V73C52.5 70.5147 54.5147 68.5 57 68.5Z",
    fill: "white",
    stroke: "#C1C1C1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90 83H64C62.3431 83 61 84.3431 61 86C61 87.6569 62.3431 89 64 89H90C91.6569 89 93 87.6569 93 86C93 84.3431 91.6569 83 90 83Z",
    fill: "#021948"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108 96H64C62.3431 96 61 97.3431 61 99C61 100.657 62.3431 102 64 102H108C109.657 102 111 100.657 111 99C111 97.3431 109.657 96 108 96Z",
    fill: "#021948"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90 110H64C62.3431 110 61 111.343 61 113C61 114.657 62.3431 116 64 116H90C91.6569 116 93 114.657 93 113C93 111.343 91.6569 110 90 110Z",
    fill: "#021948"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108 123H64C62.3431 123 61 124.343 61 126C61 127.657 62.3431 129 64 129H108C109.657 129 111 127.657 111 126C111 124.343 109.657 123 108 123Z",
    fill: "#021948"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90 137H64C62.3431 137 61 138.343 61 140C61 141.657 62.3431 143 64 143H90C91.6569 143 93 141.657 93 140C93 138.343 91.6569 137 90 137Z",
    fill: "#021948"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108 150H64C62.3431 150 61 151.343 61 153C61 154.657 62.3431 156 64 156H108C109.657 156 111 154.657 111 153C111 151.343 109.657 150 108 150Z",
    fill: "#021948"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2900_22921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 17.5H143C145.485 17.5 147.5 19.5147 147.5 22V52C147.5 54.4853 145.485 56.5 143 56.5H57C54.5147 56.5 52.5 54.4853 52.5 52V22C52.5 19.5147 54.5147 17.5 57 17.5Z",
    fill: "white",
    stroke: "#C1C1C1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90 28H64C62.3431 28 61 29.3431 61 31C61 32.6569 62.3431 34 64 34H90C91.6569 34 93 32.6569 93 31C93 29.3431 91.6569 28 90 28Z",
    fill: "#021948"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108 41H64C62.3431 41 61 42.3431 61 44C61 45.6569 62.3431 47 64 47H108C109.657 47 111 45.6569 111 44C111 42.3431 109.657 41 108 41Z",
    fill: "#021948"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2900_22921",
    x: 46,
    y: 59,
    width: 108,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2900_22921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2900_22921",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2900_22921",
    x: 46,
    y: 8,
    width: 108,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2900_22921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2900_22921",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2900_22921",
    x1: 1.1658,
    y1: 92.5,
    x2: 138.546,
    y2: 164.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011434",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011D52",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.199310ba1b3a52cdc4a14722a3545ad5.svg";
export { ForwardRef as ReactComponent };